import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

@Component({

  selector: 'app-vehicle-division',

  templateUrl: './vehicle-division.component.html',

  styleUrls: ['./vehicle-division.component.css']

})

export class VehicleDivisionComponent implements OnInit {

  lst_Report: any = [];

  lst_Search: any = [];

  lst_State: any = [];

  lst_Province: any = [];

  lst_Section: any = [];

  lst_Dehestan: any = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strState: new FormControl(''),

    strTownship: new FormControl(''),

    strSection: new FormControl(''),

    strDehestan: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.initialize();

  }

  initialize = async () => {

    await this.getState();

  }

  getState = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_State_List', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_State = res;

  }

  getProvince = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_Township_List', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Province = res;

  }

  getSection = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_Section_List', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Section = res;

  }

  getDehestan = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_Dehestan_List', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Dehestan = res;

  }

  search_Report = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post('Province_Mobile_Search', this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x123d10' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    this.lst_Report = res;

    this.lst_Search = res;


  }

  search_Total = async () => {

    window.open('/vehicle-management/division/totoal', "_blank")

  }

  openCar(item) {

    window.open(`carInfo/${item.strUnitID}`, "_blank")

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el?.strDehyarCode?.includes(val.value) ||

        el.strAbadi?.toString().includes(val.value) ||

        el.strMobileDomain_strComment?.includes(val.value) ||

        el.strState?.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.toString().replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'آمار تجهیزات به تفکیک تقسیمات سیاسی.xlsx');
  }

}
